import React from "react";
import { Space, Typography } from "antd";
import type { EventTopConsumer } from "../../../services/drinkService";
import {formatAlcohol, formatVolume} from "./utils";

const {Text} = Typography;
type TopConsumerCellProps = {consumer: EventTopConsumer | null};

const TopConsumerCell: React.FC<TopConsumerCellProps> = ({consumer}) => {
    if (!consumer) return <Text type="secondary">—</Text>;

    return (
        <Space direction="vertical" size={0}>
            <Text strong>{consumer.username}</Text>
            <Text type="secondary">
                {formatVolume(consumer.totalVolumeMl)} · {formatAlcohol(consumer.totalAlcoholGrams)}
            </Text>
        </Space>
    );
};

export default TopConsumerCell;
